import React from "react";
import MenuGrid from "../MenuGrid";

const SECTIONS = [
  {
    title: "Producción",
    items: [
      { label: "Órdenes de Producción", icon: "fas fa-clipboard-list", href: "/OrdenesProduccion", key: "produccion.ordenes.ver" },
      { label: "Producción",        icon: "fas fa-cogs",  href: "/ListadoProduccion", key: "produccion.produccion.ver" },
    ],
  },
  // {
  //   title: "Reportes",
  //   items: [
  //     { label: "Reporte Mínimos",   icon: "fas fa-exclamation-triangle", href: "/ReporteMinimos", perm: "menu_produccion" },
  //   ],
  // },
];

function BotonesPlasticos() {
  return (
    <MenuGrid
      title="Plásticos"
      subtitle="Registro de producción y compra de artículos"
      icon="fas fa-wine-bottle"
      accent={{ color: "#0ea5e9", bg: "#f0f9ff" }}
      modulo="produccion"
      sections={SECTIONS}
    />
  );
}

export default BotonesPlasticos;
